import { useEffect, useState } from "react";
import "../css/cookieConsent.css";

function CookieConsent() {

  const [show, setShow] = useState(false);

  useEffect(() => {

    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setShow(true);
    }

  }, []);

  const acceptCookies = () => {

    localStorage.setItem("cookieConsent", "accepted");
    setShow(false);

  };

  const rejectCookies = () => {

    localStorage.setItem("cookieConsent", "rejected");
    setShow(false);

  };

  if (!show) return null;

  return (

    <div className="cookie-consent">

      <div className="cookie-content">

        <h3>🍪 We Use Cookies</h3>

        <p>
          We use cookies to improve your browsing experience,
          remember your preferences, and analyze website traffic.
        </p>

        <div className="cookie-buttons">

          <button
            className="accept-btn"
            onClick={acceptCookies}
          >
            Accept
          </button>

          <button
            className="reject-btn"
            onClick={rejectCookies}
          >
            Reject
          </button>

        </div>

      </div>

    </div>

  );

}

export default CookieConsent;